module.exports = __webpack_public_path__ + "img/zoom_out.3f050609.svg";